








































import { Component, Prop, Vue } from "vue-property-decorator";
import TDSSpinner from "@/components/common/TDSSpinner.vue";

interface PageSizeOption {
    value: number;
    label: string;
}

@Component({
    components: { TDSSpinner }
})
export default class Pagination extends Vue {
    /** Zero-based index of the current page. */
    @Prop({ type: Number, required: true }) pageIndex!: number;
    @Prop({ type: Number, required: true }) totalPageCount!: number;
    /** Current page size (0 = "All"). Only used when pageSizeOptions is provided. */
    @Prop({ type: Number, default: 50 }) pageSize!: number;
    /** When provided, renders a "Per page" selector; emits `page-size-change` with the value. */
    @Prop({ type: Array, default: null }) pageSizeOptions!: Array<PageSizeOption> | null;
    /** When true, shows a small spinner in the pagination row (e.g. while a page loads). */
    @Prop({ type: Boolean, default: false }) loading!: boolean;

    /** Windowed list of 1-based page numbers with "..." gaps. */
    get pages(): Array<number | string> {
        const total = this.totalPageCount;
        const current = this.pageIndex + 1;
        if (total <= 7) {
            return Array.from({ length: total }, (_: unknown, i: number) => i + 1);
        }
        const result: Array<number | string> = [1];
        const start = Math.max(2, current - 1);
        const end = Math.min(total - 1, current + 1);
        if (start > 2) result.push("...");
        for (let p = start; p <= end; p++) result.push(p);
        if (end < total - 1) result.push("...");
        result.push(total);
        return result;
    }

    private goTo(index: number) {
        if (index < 0 || index > this.totalPageCount - 1 || index === this.pageIndex) return;
        this.$emit("change", index);
    }
}
